<template>
    <div class="message">
        <el-dialog title="紧急公告" :visible.sync="dialogVisible" width="576px" :before-close="handleClose">
            <div class="main scroll-auto">
                <div class="item" v-for="(item, index) in messageList" :key="index">
                    <h4>{{ item.title }}</h4>
                    <div class="content">
                        <p>{{ item.content }}</p>
                    </div>
                    <p v-if="item.attachment" class="file">通知附件：<a :href="item.attachment" target="_blank">点击下载</a></p>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="onSubmit">确认已阅读知晓</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
    data() {
        return {
            dialogVisible: true,
        };
    },
    props: {
        messageList: {
            type: Array,
            default: () => {
                return [];
            },
        },
    },
    computed: {
        ...mapGetters({
            getToken: "getToken",
        }),
    },
    methods: {
        ...mapActions({
            agencyMessageUpadte: "detect/agencyMessageUpadte",
        }),
        clg(){
            console.log(1);
        },
        handleClose() {
            this.dialogVisible = false;
        },
        onSubmit() {
            let ids = [];
            this.messageList.forEach((item) => {
                ids.push(item.id);
            });
            let params = {
                token: this.getToken,
                notice_id: ids.toString(),
            };
            this.agencyMessageUpadte(params).then(({ data }) => {
                this.handleClose();
            });
        },
    },
};
</script>

<style lang="scss" scoped>
.main {
    height: 400px;
    .item {
        margin-bottom: 40px;
        h4 {
            text-align: center;
            font-size: 16px;
            font-weight: 600;
            line-height: 46px;
        }
        .content {
            p {
                text-indent: 2em;
                font-size: 14px;
                line-height: 24px;
            }
        }
        .file {
            margin-top: 10px;
            a {
                color: red;
            }
        }
    }
}
::v-deep .el-dialog__footer {
    text-align: center;
}
</style>